
 import 'react-app-polyfill/ie9';
 import 'react-app-polyfill/stable';
 import 'location-origin';
 import React from 'react';
 import ReactDOM from 'react-dom';
 
 import Paddlenlp from './paddlenlp';
 
 import './style.less';
 
 
 
 ReactDOM.render(<Paddlenlp />, document.getElementById('root'));
 
 
 